import { BaseSerializer } from '../base/base.serializer';
import { WalletDesign } from './wallet-design';

export class WalletDesignSerializer extends BaseSerializer<WalletDesign> {
  fromJson(json: any): WalletDesign {
    return json as WalletDesign;
  }

  toJson(obj: WalletDesign | Partial<WalletDesign>): string {
    return JSON.parse(JSON.stringify({ wallet_design: obj }));
  }
}
